// extracted by mini-css-extract-plugin
module.exports = {"linkWrapperMobile":"nav_linkWrapperMobile__2Vkkz","navlinkBtnActive":"nav_navlinkBtnActive__3W7Qe","navlinkBtn":"nav_navlinkBtn__1c9qo","linkWrapper":"nav_linkWrapper__2C4Sq"};